var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-table__cell"},[_c('span',{staticClass:"results-table__cell-base-icon",style:(_vm.dbImage),attrs:{"title":_vm.dbName}})])}
var staticRenderFns = []

export { render, staticRenderFns }